export default __webpack_public_path__ + "static/media/busbucks.f7fbf656.jpg";